import { saveAs } from "file-saver";
import { Attachment } from "../useProcessExecutor";
import { Button } from "@/components/button";
import { Card } from "@/components/card";

interface AttachmentsProps {
  attachments: Attachment[];
}

const downloadAttachment = async (base64: string, name: string) => {
  saveAs(base64, name);
};

export const Attachments = ({ attachments }: AttachmentsProps) => {
  return (
    <Card>
      <div className="px-3">
        {attachments.map(({ name, base64 }) => (
          <div
            className="flex gap-2 justify-between items-center py-2"
            key={name}
          >
            <div className="overflow-hidden ">
              <div className="text-base font-semibold truncate">{name}</div>
            </div>
            <Button
              variant="default"
              size="sm"
              onClick={() => downloadAttachment(base64, name)}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};
